module.exports = "<div ui-view=main id=mainview></div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/notes/note.html
// module id = 454
// module chunks = 0